import Vue from 'vue';
import VueRouter from 'vue-router';
import '@/pages/ecs-dashboard/EcsDashboardPage';

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/teams',
      name: 'MSTeams',
      components: {
        'ms-teams': () => import('@/pages/ecs-ms-teams/EcsMSTeamsPage')
      }
    },
    {
      path: '/wallboard',
      name: 'eWallboard',
      components: {
        'e-wallboard': () => import('@/pages/ecs-wallboard/EcsWallboardPage')
      }
    },
    {
      path: '/',
      components: {
        'e-agent': () => import('@/pages/ecs-main/EcsMainPage.vue')
      },
      children: [
        {
          path: '/dashboards',
          name: 'Dashboards',
          component: () => import('@/pages/ecs-dashboard/EcsDashboardPage')
        },
        {
          path: '/calls',
          name: 'Calls',
          component: () => import('@/pages/ecs-telephony/EcsTelephonyPage')
        },
        {
          path: '/chats',
          name: 'Chats',
          component: () => import('@/pages/ecs-chat/EcsChatPage')
        },
        {
          path: '/emails',
          name: 'Emails',
          component: () => import('@/pages/ecs-email/EcsEmailPage')
        },
        {
          path: '/sms',
          name: 'Sms',
          component: () => import('@/pages/ecs-sms/EcsSmsPage')
        },
        {
          path: '/supervisor',
          name: 'Supervisor',
          component: () => import('@/pages/ecs-supervisor/EcsSupervisorPage')
        },
        {
          path: '/kpis',
          name: 'KPISubscriptions',
          component: () => import('@/pages/ecs-kpi-subscriptions/EcsKpiSubscriptionsPage')
        },
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('@/pages/ecs-settings/EcsSettingsPage')
        },
        {
          path: '/help',
          name: 'Help',
          component: () => import('@/pages/ecs-help/EcsHelpPage')
        }
      ]
    }
  ]
});

export default Router;
